import React from 'react'; 
import './SpeakerSlider.css';

import { Heading, TeamItem } from '../../../components';
import { speakers } from '../../../constants';

// import Swiper core and required modules 
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const SpeakerSlider = () => {

  return (

    <section>

      {/* Section heading */}
      <Heading title={'Featured Speakers'} subTitle={'Meet Our Speakers'} />

      <div className='speaker-slider'>

        <Swiper
          // install Swiper modules
          modules={[Autoplay]}
          spaceBetween={10} // Space between slides
          loop={true} // Enable infinite loop
          autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
          breakpoints= {{
            0: { 
              slidesPerView: 1, // Show 1 slide on small screens
            },
            768: {
              slidesPerView: 2, // Show 2 slides on tablets
            },
            991: {
              slidesPerView: 3, // Show 3 slides on medium screens
            },
            1200: {
              slidesPerView: 4, // Show 4 slides on larger screens
            }
          }}
        >
          {// Mapping through the Speakers array to create slides
            speakers.map((speaker, index) => {
              return (
                <SwiperSlide key={index}>

                  <TeamItem team={speaker} type="speaker" />

                </SwiperSlide>
              )
            })
          }

        </Swiper>

      </div>

    </section>

  );
}

export default SpeakerSlider;